<template>
  <div id="departments">
    <!-- <div style="padding: 10px 20px"> -->
    <div style="padding: 1px 5px" @drop="onDrop" @dragover.prevent>
      <!-- 表格区域 -->
      <vxe-grid ref="xGrid" v-bind="gridOptions" @edit-actived="mainEditActived" :scroll-y="{ enabled: true }"
        :loading="xGridLoading" show-header-overflow @cell-dblclick="noEdit" @checkbox-change="checkboxChangeEvent"
        class="affect-item" @checkbox-all="checkboxChangeEvent" @current-change="getCurrentChange" @custom="customEvent"
        :header-cell-class-name="headerCellClassName" :cell-class-name="xxcellClassName" :cell-style="{
          padding: '3px',
          'font-size': '12px',
          'line-height': '16px ',
        }">
        <template #AI_toolbar_buttons>
          <div style="display: flex">
            <div class="btn-area">
              <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addNewData('searchAddBom')"
                :disabled="!addTableListPriv">{{ $t('message.button.add') }}
              </el-button>
              <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox" :disabled="!removeBtnPriv">{{
                $t('message.button.delete') }}
              </el-button>

              <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent"
                :disabled="!pageChanged || !addTableListPriv">{{ $t('message.button.save') }}
              </el-button>
              <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave"
                :disabled="!addTableListPriv">{{ $t('message.button.cancel') }}
              </el-button>

              <el-button class="btn btn4" icon="el-icon-circle-close" @click="paste" :disabled="!addTableListPriv">
                {{ $t('message.button.paste') }}
              </el-button>

              <el-dropdown size="small" type="primary" style="margin-left: 10px" @command="handleCommand">
                <el-button type="primary" size="small">
                  {{ $t('message.button.fill')
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="up">{{
                    $t('message.button.upFill')
                  }}</el-dropdown-item>
                  <el-dropdown-item command="down">{{
                    $t('message.button.downFill')
                  }}</el-dropdown-item>

                  <!-- <el-dropdown-item command="up">向上填充</el-dropdown-item>
                  <el-dropdown-item command="down">向下填充</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>

              <el-button class="btn btn3" icon="el-icon-reading" style="margin-left: 10px" @click="generateCodeNumber()"
                :disabled="OSTButton != 1">
                {{ $t('message.button.generateItemNumber') }}
              </el-button>

              <el-button class="btn btn4" icon="el-icon-s-comment" @click="upGradeRevchangeMfrGenNumber()"
                :disabled="OSTButtons != 5">
                {{ $t('message.button.upgradeRevchangeMfrGenNumber') }}
              </el-button>

              <el-button class="btn btn5" icon="el-icon-s-release" @click="itemCancelItemNumber()"
                :disabled="OSTCancelButton == 0">
                {{ $t('message.button.cancelCode') }}
              </el-button>

              <el-button class="btn btn5" icon="el-icon-document-copy" :disabled="CBVisible"
                @click="copyChangeAffectedItem()">
                {{ $t('message.button.copy') }}
              </el-button>
              <div class="upload-btn" :disabled="getStatusType()" v-if="getMatchAttachment()">
                <label for="upFileDdirectory" class="up-button btn-right">
                  <span>{{ $t('message.button.MatchAttachment') }}</span>
                  <input type="file" id="upFileDdirectory" class="up-file" webkitdirectory directory multiple
                    @change="selectFolder" />
                </label>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:operate="{ row }">
          <div class="flag" style="width: 180px">
            <div v-for="i in 3" :key="i" :title="getRowFlag(row, i).title" class="flag-icon" @click="checkInfo(row)">
              <i :class="getRowFlag(row, i).icon"></i>
            </div>
            <div class="ope" @click="checkInfo(row)">
              <i class="el-icon-s-grid"></i>
            </div>
          </div>
        </template>

        <template #bottom>
          <BottomTips :data="{ selectRecords: selectRecords.length, totalRecords }" />
        </template>
      </vxe-grid>
    </div>

    <div v-if="redLine && tab.length">
      <div style="display: flex; align-items: center; width: 100%">
        <div class="content-title">
          <div @click="tabClick(item, index)" class="content-item" :class="{ active: index == num }"
            v-for="(item, index) in tab" :key="index">
            <div>
              {{ item.name }}
            </div>
          </div>
        </div>
        <div style="margin-left: auto; margin-right: 75px; width: 40px">
          <el-button icon="el-icon-printer" type="primary" size="mini" v-show="num == 0" @click.native="printPage">
            {{ $t('message.button.print') }}
          </el-button>
        </div>
      </div>
      <div style="height: 3px; background: #ebebeb"></div>

      <component :key="getComponentKey()" :is="tab[num].id" id="print"
        :changePrivs="{ add: addTableListPriv, remove: removeBtnPriv }" :itemInfo="itemInfo" :dataInfo="attachmentInfo"
        @reloadPage="reloadPage" />
    </div>

    <el-dialog v-dialogDrag v-if="searchAddBom" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="searchAddBom" :close-on-click-modal="false" :close-on-press-escape="false" width="60%">
      <searchAdd @listDbClick="addList" :creatBy="creatBy">
        <div>
          <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="creatNew = true">{{
            $t('message.button.create') }}</el-button>
        </div>
      </searchAdd>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="creatNew" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="creatNew" :close-on-click-modal="!creatNew">
      <Create :creatBy="creatBy" :saveUrl="saveTableUrl" :baseClass="baseClass_" @addToList="creatNewModel"
        @closeCreateNew="closeCreateNew" :departmentList="departmentList"></Create>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="copyAffectedItem" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="copyAffectedItem" :close-on-click-modal="false" :close-on-press-escape="false" width="60%">
      <copyChangeAffectedItemVue :copyAffectedItems="copyAffectedItems"></copyChangeAffectedItemVue>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height: 270px">
        <div style="margin: 60px auto; padding-left: 50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width: 75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left: 10px" @click="getCascadeValue">{{
            $t('message.button.affirm') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title="附件匹配" :visible.sync="MatchAttachmentDialogVisible" width="50%">
      <div>
        <uploader ref="uploader" :matchAttach="matchAttach" @reloadPage="reloadPage"></uploader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClosedUpload">取 消</el-button>
        <el-button type="primary" @click="confirmUploadDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BottomTips from '@/components/bottomTips.vue'
import searchAdd from '@/components/searchAdd.vue' //引进菜单模板
import uploader from '@/components/uploaderFolder.vue'
import Create from '@/components/common/Create.vue'

import {
  titleblock_redline,
  Bom_redLine,
  manufacturer_redLine,
  attachment_redLine,
  copyChangeAffectedItemVue,
} from './changeAI/index'
import {
  getNewTableContentData,
  getNewTableTitleData,
  gridOptions,
  setListEntry,
} from './changeAI/affectItemConfig'

import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import { getTab, LINK_LIST } from '@/utils/constants'
import { dialogDrag } from '@/utils/directive'
import { getTabIndex } from '@/utils/index.js'

import Vue from 'vue'

Vue.directive('dialogDrag', dialogDrag)

export default {
  data() {
    return {
      MatchAttachmentDialogVisible: false,
      OSTButton: -1,
      OSTButtons: -1,
      //itemList:[],
      OSTCancelButton: 0,
      itemInfo: {},

      attachmentInfo: {}, //给ai附件组件传值 obs

      redLine: false,
      titleblock_redline: true,
      Bom_redLine: false,
      manufacturer_redLine: false,
      attachment_redLine: false,

      num: 0,
      tab: [],
      itemData: '',
      tabOther: [], //ECO redline显示的tab
      tabMCO: [], //MCO redline显示的tab
      // tabECR: [], //ECR redline显示的tab
      tabTechnology: [],
      fileList: [],
      createClassId: '',
      saveTableUrl: '',
      creatNew: false,

      createClassId2: '',
      saveTableUrl2: '',

      searchAddBom: false, //添加窗口开关
      //oldTableValue: {},
      version: '',

      selectRecords: [],
      totalRecords: '',
      pageIndex: 2,
      dataComplete: false,
      finished: true,
      xGridLoading: false,
      gridOptions: { ...gridOptions, height: '500' },

      // majorInfo: {},
      // getAlt: false,

      leftShow: true,
      showBtn: false,
      // creatByChangedItem:'changedItem',
      // creatByBOM :'BOM',

      loading: true,
      aiCols: [], //ai表头
      get_change_info: '', //父组件传来的值

      redLineRow: {},
      baseClass_: '',

      //权限

      addTableListPriv: false,
      removeBtnPriv: false,

      cachePnameList: [],

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {},
      matchAttach: '',
      seekId: '',
      seekColumns: '',
      tempCell: {},
      options: [],
      value: '',
      loading: false,
      index: '',
      searchQuery: '',
      // tabColumn:[],
      // tempColumns:[]
      copyAffectedItem: false,
      copyAffectedItems: [],
      CBVisible: true,

      attVal: 11,
    }
  },
  mounted() { },
  components: {
    Create,
    searchAdd,
    attachment_redLine,
    titleblock_redline,
    Bom_redLine,
    manufacturer_redLine,
    copyChangeAffectedItemVue,
    BottomTips,
    uploader,
  },
  methods: {


    getStatusType() {

      return this.workFlowStatus == 3 || this.workFlowStatus == 4
    },

    getMatchAttachment() {

      const systemCode = window.sessionStorage.getItem('systemCode') || ''
      return systemCode.toLocaleLowerCase().indexOf('hlw') !== -1
    },

    //确认附件上传
    async confirmUploadDialog() {
      await this.$refs.uploader.beforeUpLoad(this.fileList)
      //上传成功
      this.MatchAttachmentDialogVisible = false
      document.getElementById('upFileDdirectory').value = null
    },
    dialogClosedUpload() {
      this.MatchAttachmentDialogVisible = false
      document.getElementById('upFileDdirectory').value = null
    },
    reloadPage() {
      this.getInitData()
      this.attVal++

    },
    getCurrentChange(val) {
      const { newValue } = val
      this.checkInfo(newValue)
    },
    MatchAttachmentDialogClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    onDrop(event) {
      const vm = this
      if (!vm.addTableListPriv) {
        return
      }
      const fieldData = this.$store.state.dragMenu
      const query = this.$route.query
      const startsWith104 = String(query.classId).startsWith('104')
      if (
        (fieldData.type !== 101 && fieldData.type !== 501) ||
        !startsWith104
      ) {
        return
      }
      const insertAffectedItem = []
      const obj = {
        item: fieldData.id,
        itemNumber: fieldData.name,
        changeId: this.objId.id,
      }
      insertAffectedItem.push(obj)

      const updateBomData = {
        //post更改的值
        tableId: 5,
        changeObjId: { ...this.objId, version: this.version },
        insertAffectedItem: insertAffectedItem,
        isAdd: '0',
      }
      axios
        .post('/pmdm/changes/saveTable', updateBomData)
        .then((res) => {
          if (res.data.code == 200) {
            const { errList = [], insertAffectedItem } = res.data.object

            if (errList.length) {
              let str = ''
              errList.forEach((i) => {
                str += `<p>${i}</p>`
              })

              vm.$message({
                dangerouslyUseHTMLString: true,
                message: str,
                type: 'warning',
              })
              errList.length < insertAffectedItem.length && vm.getInitData()
              return
            } else {
              vm.$message({
                dangerouslyUseHTMLString: true,
                message: res.data.message,
                type: 'success',
              })
              vm.dataComplete = false
              vm.pageIndex = 2
              vm.getInitData()
            }
          } else {
            vm.$message.error(res.data.message)
          }
        })
        .catch(function (error) { })
    },

    printPage() {
      // window.print()
      let newstr = document.getElementById('print').innerHTML
      let oldstr = document.body.innerHTML
      document.body.innerHTML = newstr
      window.print()
      document.body.innerHTML = oldstr

      this.$nextTick(() => {
        window.location.reload()
        this.num = 0
      })
    },
    headerCellClassName({ column }) {
      if (column.editRender && column.editRender?.enabled) {
        return 'col-blue'
      }
      return null
    },

    xxcellClassName({ row, column }) {
      if (column.editRender && column.editRender?.enabled) {
        if (!this.addTableListPriv) {
          return 'release-column'
        } else {
          return 'col-custom-edit'
        }
      }
    },

    getUserkeywords(event) {
      this.searchQuery = event.target.value
      this.getUserListBasedOnKeywords(this.searchQuery)
    },

    getUserListBasedOnKeywords(keywords) {
      this.options = []
      const url = `/pmdm/items/simpleSearchByItemNumber${this.params({
        value: keywords,
      })}`
      axios
        .get(url)
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.object.rows
            this.options = data.map((item) => ({
              value: item.cells[0].val,
              label: item.cells[0].val,
            }))
          } else {
          }
        })
        .catch((error) => {
        })
    },

    ...mapMutations([
      'setPageChanged',
      'setPageRefresh',
      'replaceShowingTabsInHome',
      'setActivedTabInHome',
    ]),

    getRowFlag(row, index) {
      // const t = Number(row.itemId) % 2 ?
      const arr = [
        { title: '历史变更', icon: 'el-icon-data-line' },
        { title: 'BOM', icon: 'el-icon-news' },
        { title: '附件', icon: 'el-icon-document' },
      ]
      const { hasRev = 0, isBOM = 0, isFile = 0 } = row
      const list = [hasRev, isBOM, isFile]
      const e = index - 1
      const t = list[e]
      // const icon = t ?  arr[e].icon : 'holder';
      let { title, icon } = arr[e]
      icon = t ? icon : 'holder'
      const str = t ? '有' : '无'
      return { icon, title: str + title }
    },

    addNewData(dialogName) {
      if (this.pageChanged) {
        this.saveConfirm()
        return
      }
      // this[dialogName] = true
      this.searchAddBom = true
    },

    saveConfirm() {
      this.$confirm('当前页面有未保存信息，请先保存', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        // cancelButtonText: "取消",
        type: 'warning',
      })
    },

    paste() {
      const rows = this.$store.getters.getCopyItems
      if (!rows.length) {
        this.$message.error('没有可粘贴items')
        return
      }
      this.addList(rows)
    },

    resetCol(e) {
      const [col, All] = e

      const arr = []
      All.map((i, e) => {
        if (col.includes(i)) {
          const obj = this.tempColumns.find((j) => j.title === i)
          arr.push(obj)
        }
      })
      this.gridOptions.columns = [
        // {
        //   title: "flag",
        //   width: 80,
        //   slots: {
        //     default: "rowFlag",
        //   },
        // },

        {
          title: '',
          width: 105,
          fixed: null,
          slots: {
            default: 'operate',
          },
        },
        {
          type: 'checkbox',
          width: 45,
          fixed: null,
        },
        ...arr,
      ]
      const str = col.join(';') + '_' + All.join(';')
      this.saveColumnsRes(str)
    },

    saveColumnsRes(str) {
      let obj = {
        baseId: 104,
        clsId: this.objId.classId,
        subId: this.objId.subClassId,
      }

      let seekVo = {
        ...obj,
        saveColumns: str,
        isPublic: 13,
        name: Date.now() + '',
      }
      this.seekId && Object.assign(seekVo, { id: this.seekId })

      axios
        .post('/search/advanced/saveSeek', { seekVo })
        .then((res) => {
          this.seekId = res.data.object.result.id
        })
        .catch((_) => { })
    },

    handleCommand(command) {
      // this.$message('click on item ' + command);

      const { row, column, rowIndex, columnIndex } = this.tempCell

      const list = this.$refs.xGrid.getData()
      list.map((i, e) => {
        if (
          (command == 'up' && e < rowIndex) ||
          (command == 'down' && e > rowIndex)
        ) {
          i[column.property] = row[column.property]
        }
        // if(){
        //   i[column.property] = row[column.property]
        // }
      })
    },

    /**
     * Gary
     * 生成正式的物料编码/升级制造商
     * @param {*}
     */
    upGradeRevchangeMfrGenNumber() {
      var allItems = [] //拿到item的所有的信息
      for (var i = 0; i < this.itemList.length; i++) {
        var obj = {}
        obj.id = this.itemList[i].id
        obj.classId = this.itemList[i].classId
        obj.subclassId = this.itemList[i].subclassId
        allItems.push(obj)
      }

      var generateCodeNumber = {
        Items: allItems,
        changeId: this.changeObjId.changeId,
      }

      axios
        .post(`/pmdm/items/upGradeRevchangeMfrGenNumber`, generateCodeNumber)
        .then((res) => {
          if (res.data.code == 200) {
            const { codeId, error, success } = res.data.object

            if (codeId == 20007) {
              var errors = []
              for (var i = 0; i < error.length; i++) {
                const a = error[i].itemMessage
                const b = error[i].msg
                errors.push(a)

                errors.push(b)
                errors.push('</br>')
              }
              var s = errors.toString()
              var strs = s.split(',').join('')

              this.$message({
                dangerouslyUseHTMLString: true,
                message: strs,
                type: 'error',
              })
            } else if (codeId == 200) {
              this.$message({
                message: res.data.message,
                //type: "success",
                type: 'success',
              })
            }
            this.dataComplete = false
            this.pageIndex = 2
            this.getInitData()
          }
        })
        .catch(function (error) { })
    },

    /**
     * Gary
     * 生成正式的物料编码/升级制造商
     * @param {*}
     */
    generateCodeNumber() {
      var allItems = [] //拿到item的所有的信息
      for (var i = 0; i < this.itemList.length; i++) {
        var obj = {}
        obj.id = this.itemList[i].id
        obj.classId = this.itemList[i].classId
        obj.subclassId = this.itemList[i].subclassId
        allItems.push(obj)
      }

      var generateCodeNumber = {
        Items: allItems,
        changeId: this.changeObjId.changeId,
      }

      axios
        .post(`/pmdm/items/itemUpgradeOperation`, generateCodeNumber)
        .then((res) => {
          if (res.data.code == 200) {
            const { codeId, error, success } = res.data.object

            if (codeId == 20007) {
              var errors = []
              for (var i = 0; i < error.length; i++) {
                const a = error[i].itemMessage
                const b = error[i].msg
                errors.push(a)

                errors.push(b)
                errors.push('</br>')
              }
              var s = errors.toString()
              var strs = s.split(',').join('')

              this.$message({
                dangerouslyUseHTMLString: true,
                message: strs,
                type: 'error',
              })
            } else if (codeId == 200) {
              this.$message({
                message: res.data.message,
                //type: "success",
                type: 'success',
              })
            }
            this.dataComplete = false
            this.pageIndex = 2
            this.getInitData()
          }
        })
        .catch(function (error) { })
    },

    /**
     * Gary
     * 取消正式编码
     */
    itemCancelItemNumber() {
      var allItems = [] //拿到item的所有的信息
      for (var i = 0; i < this.itemList.length; i++) {
        var obj = {}
        obj.id = this.itemList[i].id
        obj.subclassId = this.itemList[i].subclassId
        allItems.push(obj)
      }

      var upgradeSequence = {
        cancelItems: allItems,
        changeId: this.changeObjId.changeId,
      }
      axios
        .post(`/pmdm/items/itemCancelItemNumbers`, upgradeSequence)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.dataComplete = false
            this.pageIndex = 2
            this.getInitData()
          }
        })
        .catch(function (error) { })
    },

    /**
     * Gary添加利用编码生成器生成编码的代码
     * @param {*} checked
     */
    checkboxChangeEvent(checked) {
      const records = checked.records

      this.selectRecords = records
      if (records.length) {
        this.$store.commit('setRecords', records)
        let vm = this
        var allCheckedItem = []
        for (var i = 0; i < records.length; i++) {
          var obj = {}
          obj.id = records[i].itemId
          obj.classId = records[i].itemClassId
          obj.subclassId = records[i].itemSubClassId
          allCheckedItem.push(obj)
        }
        var allItemData = {
          changeId: this.changeObjId.changeId,
          changeClassId: this.changeObjId.changeClassId,
          allCheckedItem: allCheckedItem,
        }

        axios
          .post('/pmdm/items/getItemButtonTypeByIds', allItemData)
          .then(function (res) {
            if (res.data.code == 200) {
              vm.dupTag = res.data.object.dupTag
              if (vm.dupTag == true) {
                // vm.itemUpgradeCodeList = res.data.object.itemUpgradeCodeList;
                //拿到所有的item
                vm.itemList = res.data.object.itemList
                // vm.itemUpgradeSequenceList = res.data.object.itemUpgradeSequenceList;

                vm.flags = res.data.object.flag
                //flag等于1.表明只有生成物料编码的按钮亮
                if (vm.flags == 1) {
                  vm.OSTButton = 1
                  vm.OSTCancelButton = 1
                  //flag等于5.表明只有升级版本/变更制造商的按钮亮
                } else if (vm.flags == 5) {
                  vm.OSTButtons = 5
                  vm.OSTCancelButton = 1
                  //flag等于2.表明两个按钮都会亮
                } else if (vm.flags == 2) {
                  vm.OSTButton = 1
                  vm.OSTButtons = 5
                  vm.OSTCancelButton = 1
                }
              }
            }
          })
          .catch(function (error) { })
      } else {
        this.OSTButton = -1
        this.OSTButtons = -1
        this.OSTCancelButton = 0
      }
    },

    customEvent({ type, $table }) {
      if (type != 'confirm') {
        return
      }
      let obj = {
        baseId: 104,
        clsId: this.objId.classId,
        subId: this.objId.subClassId,
      }
      const currentColumns = $table.getColumns().map((i) => i.property)

      const saveColumns = $table.tableFullColumn
        .filter((i) => !currentColumns.includes(i.property))
        .map((i) => i.property)
        .join(';')
      let seekVo = { ...obj, saveColumns, isPublic: 13, name: Date.now() + '' }
      this.seekId && Object.assign(seekVo, { id: this.seekId })

      axios
        .post('/search/advanced/saveSeek', { seekVo })
        .then((res) => {
          this.seekId = res.data.object.result.id
        })
        .catch((_) => { })
    },
    setColumns() {
      if (!this.seekColumns.length) {
        return
      }
      this.gridOptions.columns
        .filter((i) => this.seekColumns.split(';').includes(i.field))
        .map((i) => {
          const column = this.$refs.xGrid.getColumnByField(i.field)
          this.$refs.xGrid.hideColumn(column)
        })
    },
    closeCreateNew() {
      this.creatNew = false
    },
    tabClick(res, index) {
      this.num = index
      const obj = {
        ...this.$store.state.objectId,
        secIndex: index,
      }
      this.$store.commit('setTabIndex', obj)
    },
    creatNewModel(e) {
      this.addList(e)
      this.creatNew = false
      this.searchAddBom = false
    },
    async getLCPData(obj) {
      const { data } = await this.$http.get(
        `/pmdm/admin/lifecycle/getLifecyclePhaseBySubclass${this.params(obj)}`
      )
      const { phases = [] } = data.object
      const arr = phases
        .filter((i) => i.enabled)
        .map((i) => ({ label: i.phaseName, value: i.id }))
      return arr
    },
    async noEdit({ row, column, rowIndex, columnIndex }) {
      if (!this.addTableListPriv) {
        return false
      }

      this.tempCell = { row, column, rowIndex, columnIndex }

      let subClsIdListId = this.gridOptions.columns[columnIndex]

      if (subClsIdListId.attid == '1005007') {
        const obj = { subclassId: row.itemSubClassId }
        this.getLCPData(obj).then((res) => {
          this.cachePnameList = this.cachePnameList.concat(res)
          this.gridOptions.columns[columnIndex].editRender.options = res
        })
      }

      if (column?.editRender?.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions
        let m = row[[column.property]]
        if (column.editRender.props.multiple) {
          this.cascaderValue = m
            ? m.map((i) => {
              return this.getParentIdList(this.cascaderList, i)
            })
            : ''
          this.cascaderProps.multiple = true
        } else {
          this.cascaderProps.multiple = false
          this.cascaderValue = m
        }
        this.cascaderProps.checkStrictly = true
        this.tempData = { row, column }
        this.cascaderShow = true
      }
    },

    formatPanmeLabel({ cellValue, row }) {
      let num = 0
      this.gridOptions.columns.map((item, index) => {
        if (item.attid == 1005007) {
          num = index - 2
        }
      })
      let str = row[num]
      this.cachePnameList.map((item) => {
        if (item.value == cellValue) {
          str = item.label
        }
      })
      return str
    },
    getBaseId() {
      if (this.objId.classId == 10410) {
        ; (this.baseClass_ = '501'),
          (this.saveTableUrl = '/pmdm/technology/saveTechnologyP1P2P3')
      } else {
        ; (this.baseClass_ = '101'),
          (this.saveTableUrl = '/pmdm/items/saveItemP1P2P3')
      }
    },
    // formatLCP({ cellValue, row }) {

    //   let ptype = row.itemSubClassId;
    //   let ptypeItem = this.cachePnameList.find(
    //     (item) => item.itemSubClassId_ === ptype
    //   );

    //   if (ptypeItem && ptypeItem.select_val) {
    //     let pnameItem = ptypeItem.select_val.find(
    //       (item) => item.value == cellValue
    //     );
    //     if (pnameItem) {
    //       return pnameItem.label;
    //     }
    //   }
    //   return cellValue;
    // },

    // itemUpgradeOperations   id   buttonType  cId    buttonType

    getComponentKey() {
      const { rowId = '' } = this.redLineRow
      return rowId + this.attVal
    },

    removeCheckbox() {
      //删除 this.redLineRow
      if (this.pageChanged) {
        this.saveConfirm()
        return
      }
      this.$confirm(this.$t('message.confirm.deleteData'))
        .then((_) => {
          //done();
          var change_info = this.change_info
          //var removeRow = this.$refs.xGrid.removeCheckboxRow();
          var removeRow = this.$refs.xGrid.getCheckboxRecords()

          var del_table = []
          var vm = this
          if (removeRow.length == 0) {
            vm.$message({
              message: this.$t('message.tips.dele_data'),
              type: 'warning',
            })
            return false
          } else {
            for (var i = 0; i < removeRow.length; i++) {
              var obj = {}
              obj.id = removeRow[i].rowId
              del_table.push(obj)
            }

            var delAIData = {
              tableId: 5,
              changeObjId: {
                ...this.objId,
                version: this.version,
              },
              deleteAffectedItem: del_table,
            }
            const hasChecked = removeRow.some(
              (i) => i.rowId === this.redLineRow.rowId
            )
            axios
              .post('/pmdm/changes/deleteTable', delAIData)
              .then(function (res) {
                if (res.data.code == 200) {
                  vm.$message({
                    message: res.data.message,
                    type: 'success',
                  })

                  vm.dataComplete = false
                  vm.pageIndex = 2
                  vm.getInitData()

                  vm.redLineRow = {}
                  vm.selectRecords = []
                  if (hasChecked) {
                    vm.itemInfo = {}
                    const res = {
                      name: vm.$t('message.title.titleBlock'),
                    }
                    vm.tabClick(res, 0)
                  }
                }
              })
              .catch(function (error) { })
          }
        })
        .catch((_) => { })
    },

    addList(row) {
      //添加

      if (row) {
        let insertAffectedItem = row.map((i) => {
          return {
            item: i.id,
            itemNumber: i.itemNumber,
            changeId: this.objId.id,
          }
        })

        var updateBomData = {
          //post更改的值
          tableId: 5,
          changeObjId: { ...this.objId, version: this.version },
          insertAffectedItem: insertAffectedItem,
          isAdd: row[0].isAdd,
        }

        var vm = this
        axios
          .post('/pmdm/changes/saveTable', updateBomData)
          .then((res) => {
            if (res.data.code == 200) {
              const { errList = [], insertAffectedItem } = res.data.object

              if (errList.length) {
                let str = ''
                errList.forEach((i) => {
                  str += `<p>${i}</p>`
                })

                vm.$message({
                  dangerouslyUseHTMLString: true,
                  message: str,
                  type: 'warning',
                })
                errList.length < insertAffectedItem.length && vm.getInitData()
                return
              } else {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: res.data.message,
                  type: 'success',
                })
                this.dataComplete = false
                this.pageIndex = 2
                this.getInitData()
              }
            } else {
              // this.$message.error(res.data.message)
            }
          })
          .catch(function (error) { })
      }
    },

    handleClose(done) {
      this.$confirm(this.$t('message.confirm.close'))
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },

    closeSave() {
      this.setPageChanged({ name: this.componentname, isChanged: false })
      this.$refs.xGrid.revertData() //清除所有保存，删除，添加记录
    },

    getUpdateEvent() {
      var xGrid_ = this.$refs.xGrid
      let updateRecords = this.$refs.xGrid.getUpdateRecords() //获取修改的行

      var updateAffectedItem = []

      if (updateRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i])
          var cols_length = this.aiCols
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], '' + j)
            if (updateNewData) {
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {}
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j]
                  obj.id = updateRecords[i].rowId

                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(';')
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      'datetime'
                    ) {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        'yyyy-MM-ddThh:mm:ss'
                      )
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = ''
                      } else {
                        obj[quantity] = updateRecords[i][j]
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = ''
                    } else {
                      obj[quantity] = updateRecords[i][j]
                    }
                  }
                  updateAffectedItem.push(obj)
                }
              }
            }
          }
        }
        var change_info = this.change_info

        var updateBomData = {
          //post更改的值
          tableId: 5,
          changeObjId: { ...this.objId, version: this.version },
          updateAffectedItem: updateAffectedItem,
        }
        var vm = this
        axios
          .post('/pmdm/changes/updateTable', updateBomData)
          .then(function (res) {
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: 'success',
              })
              vm.getInitData()
              xGrid_.revertData()
              vm.tempCell = {}
              vm.setPageChanged({ name: vm.componentname, isChanged: false })
            }
          })
          .catch(function (error) { })
      }

      //this.clearAll();
      //this.editShow = true;
      //this.showBtn = true;
      // this.$refs.pageInfoRedline.getTitleBlockInfo();
    },
    activeRowMethod({ row, rowIndex }) {
      if (row.disable) {
        return false
      }
      return true
    },

    showDetailEvent(row) {
      const obj = {
        id: row.itemId,
        classId: row.itemClassId,
        subClassId: row.itemSubClassId,
        title: row[0],
      }
      this.getLink(obj)
    },
    async getInitData() {
      this.OSTButton = -1
      this.OSTButtons = -1
      this.OSTCancelButton = 0

      this.redLine = [10401, 10402, 10410].includes(this.objId.classId)
      const change_info = this.get_change_info || this.change_info
      this.xGridLoading = true

      var obj_get = {
        ...this.objId,
        ...change_info,
        tableId: 5,
      }
      const { data } = await this.$http.get(
        `/pmdm/changes/loadTable${this.params(obj_get)}`
      )
      const {
        columnInfo,
        rows,
        seekId,
        saveColumns = [],
        version,
      } = data.object.table
      this.version = version
      const { listIds, listTypes, uiTypes, listEntries } = columnInfo

      const lisE = setListEntry(
        { listIds, listTypes, uiTypes, listEntries },
        rows
      )

      this.seekId = seekId
      this.seekColumns = saveColumns || []
      this.gridOptions.columns = getNewTableTitleData(columnInfo)

      const systemName = window.sessionStorage.getItem('systemName')

      this.gridOptions.columns.map((item, index) => {
        const { attid: attrId } = item

        if (LINK_LIST.includes(attrId)) {
          item.slots = {
            default: ({ row, column }, h) => {
              // 渲染链接
              return [
                <span
                  class="link_"
                  onClick={() => this.showDetailEvent(row, column)}
                >
                  {row[column.property]}
                </span>,
              ]
            },
          }
        }

        if (attrId == 1005007) {
          item.formatter = this.formatPanmeLabel
        }
        if (attrId == 1005007 && systemName.indexOf('帝京') !== -1) {
          //帝京定制，作废，版本生成EOL
          item.editRender.events = { change: this.selfChange }
        }
      })

      this.departmentList = Object.entries(lisE[10001]).map((i) => {
        const [value, label] = i
        return { value, label }
      })
      //this.gridOptions.columns.splice(0,1);
      var operation = [
        {
          title: '',
          width: 105,
          slots: {
            default: 'operate',
          },
        },
      ]
      this.gridOptions.columns = [...operation, ...this.gridOptions.columns]

      this.aiCols = columnInfo.ids
      this.gridOptions.data = getNewTableContentData(rows, columnInfo)
      this.xGridLoading = false
    },

    selfChange({ column, row, cell }) {
      let cellValue = row[column.property]
      let index_ = this.getCellIndex(1005005)

      let cellCNVal = ''
      column.editRender.options.map((item) => {
        if (item.value == cellValue) {
          cellCNVal = item.label
        }
      })

      if (cellCNVal == '作废') {
        row[index_] = 'EOL'
      }
    },
    toLink(e, c) {
      const n = parseInt(c.property)
      const { id, classId, subclassId, val: title } = e.link[n]
      this.getLink({ id, classId, subclassId, title })
    },

    getCellIndex(num) {
      let columns = this.gridOptions.columns
      let index_ = 0

      columns.map((item, index) => {
        if (item.attid == num) {
          index_ = index
        }
      })
      return index_ - 2
    },

    removeRowEvent(row) { },

    async checkInfo(row) {
      //如果没有AItable编辑权限，则不显示redline的table
      const obj = { ...this.$store.state.objectId, row }
      this.$store.commit('setTabIndex', obj)
      this.redLineRow = row

      if (![10401, 10402, 10410].includes(this.objId.classId)) {
        return
      }
      this.itemInfo = {
        id: row.itemId,
        classId: row.itemClassId,
        subClassId: row.itemSubClassId,
        ...this.changeObjId,
        version: this.version,
      }
      this.attachmentInfo = {
        ...this.itemInfo,
        tableId: this.Global.redLineAttachmentTableId,
        isrelase: this.addTableListPriv,
      }
    },
    selectFolder(event) {
      const { id, classId, subClassId } = this.$route.query
      // this.itemData = { id, classId, subClassId }
      const { files } = event.target
      let num = 1
      for (const key in files) {
        if (Object.prototype.hasOwnProperty.call(files, key)) {
          const element = files[key]
          element.order = num + element.lastModified
          this.fileList.push(files[key])
          num++
        }
      }
      if (!this.fileList.length) {
        alert('文件夹为空！')
      }
      const fileNameList = this.fileList.map((i) => i.name)
      const param = {
        id,
        classId,
        subClassId,
        fileNameList,
      }
      axios
        .post('/pmdm/custom/getAIFileMapping', param)
        .then((res) => {
          if (res.data.code == 200) {
            this.matchAttach = res.data.object.AIFileInfo.map(item => {
              const { fileName, relatedDoc } = item
              item.isDelete = !!fileName;
              item.isUpload = !!fileName;
              item.relatedDoc = relatedDoc.map(j => {
                const { oldNumber: name, classId, id } = j
                return { name, classId, id }
              })
              return item
            })

            this.MatchAttachmentDialogVisible = true
          }
        })
        .catch((error) => {
        })
    },
    clax(item) {
      axios
        .get('pmdm/admin/list/getObjectInfoByListId?listEntryId=' + item.value)
        .then((res) => {
          const obj = { ...res.data.object, title: item.label }
          this.getLink(obj)
          this.$store.commit('setPageRefresh')
        })
    },
    mainEditActived({ row, column }) {
      this.setPageChanged({ name: this.componentname, isChanged: true })
      this.getListEntry({ column, row })
    },
    getListEntry({ row, column }) {
      if (this.objId.classId == 10403) {
        const { revNumberList = [] } = row
        const options = revNumberList.map((i, e) => ({ label: i, value: i }))

        if (column.field == '2') {
          column.editRender = {
            name: '$select',
            props: {
              clearable: true,
            },
            options,
          }
        }
      }
    },

    loadUserPriv() {
      let changeWorkflowStatus = this.$store.state.changeWorkflowStatus
      if (changeWorkflowStatus == 3) {
        this.CBVisible = false
      } else {
        this.CBVisible = true
      }

      this.getPriv().then((res) => {
        const { addModPriv, delPriv } = res.data.object

        const isSuperAdmin = this.$store.state.isSuperAdmin

        this.addTableListPriv = isSuperAdmin || addModPriv
        this.removeBtnPriv = isSuperAdmin || delPriv
        const class_Id = this.objId.classId
        this.tab = getTab(class_Id)
      })
    },

    getConfirm() {
      this.$confirm('受影响物件的旧版附件是否加载到新版本', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then((res) => { })
    },

    getPriv() {
      const obj_get = {
        ...this.$store.state.objectId,
        changeId: 0,
        changeClassId: 0,
        changeSubClassId: 0,
        tableId: 5,
      }
      return axios.get(
        `/pmdm/relationship/hasCustomerPriv${this.params(obj_get)}`
      )
    },

    copyChangeAffectedItem() {
      var copyItemRow = this.$refs.xGrid.getCheckboxRecords()
      if (copyItemRow.length == 0) {
        this.$message({
          showClose: true,
          message: '请选择需要复制的数据',
          type: 'warning',
        })
        return
      }
      this.copyAffectedItem = true
      this.copyAffectedItems = copyItemRow
    },
  },
  created() {
    this.getInitData()
    this.loadUserPriv()
    this.getBaseId()

    this.$nextTick(() => {
      const item = getTabIndex()
      const { row = '', secIndex = 0 } = item
      if (!!row) {
        this.checkInfo(row)
        this.$refs.xGrid.setActiveRow(row)
        this.num = secIndex
      }
    })
    // setTimeout(() => {
    //   this.loading = false;
    // }, 500);
  },
  // props: ["changeValue"],
  // watch: {
  //   changeValue: function (value) {
  //     this.get_change_info = value;

  //     this.getInitData();
  //     this.loadUserPriv();
  //     this.num = 1;
  //   },
  // },
  computed: {
    creatBy() {
      return this.searchAddRedLine ? 'BOM' : 'affectedItem'
    },

    workFlowStatus() {
      return this.$store.state.changeWorkflowStatus;
    },

    ...mapState({
      pageChanged: (state) => state.pageChanged,
      tabs: (state) => state.showingTabsInHome,
      activeName: (state) => state.activedTabInHome,
      objId: (state) => state.objectId,
      change_info: (state) => state.change_info,
      changeObjId: (state) => {
        const {
          id: changeId,
          classId: changeClassId,
          subClassId: changeSubClassId,
        } = state.objectId
        return {
          changeId,
          changeClassId,
          changeSubClassId,
        }
      },
    }),
    componentname() {
      const { id, classId, subClassId } = this.$store.state.objectId
      return ' ' + id + classId + subClassId
    },
  },
  beforeRouteLeave(to, from, next) {
    const tabs = [...this.$store.state.showingTabsInHome]
    const activeName = this.$store.state.activedTabInHome
    if (!this.$store.state.pageChanged) {
      this.$store.commit('setNavigationTriggered', false)
      return next()
    }
    const navigationTriggered = this.$store.state.navigationTriggered

    if (navigationTriggered) {
      to = this.$store.state.routerTo
      from = this.$store.state.routerFrom
      return next(false)
    } else {
      this.$store.commit('setRouterTo', to)
      this.$store.commit('setRouterFrom', from)
    }

    this.$store.commit('setNavigationTriggered', true)

    this.$confirm('当前页面有未保存信息，确定离开么', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.setPageChanged({ name: this.componentname, isChanged: false })
        this.$store.commit('setNavigationTriggered', false)
        next(to)
        if (to.path == from.matched[1].path) {
          this.setPageRefresh()
        }
      })
      .catch(() => {
        this.replaceShowingTabsInHome(tabs);
        this.setActivedTabInHome(activeName);
        this.$store.commit('setNavigationTriggered', false);
        next(false)
      })
  },
}
</script>

<style>
.affect-item .vxe-header--column.col-blue span {
  /* background-color: #4b92ff; */
  color: #4b92ff;
}

.affect-item .vxe-body--column.col--dirty span {
  color: #f56c6c;
  font-weight: 600;
}

.affect-item .vxe-body--column.col-custom-edit {
  background: #d8e6f8;
  border: #b1d2fa 1px solid;
}

.affect-item .vxe-body--column.release-column span {
  color: #f56c6c;
}

.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
  text-decoration: line-through;
  color: red;
}

.mytable-style .vxe-body--column.col-red span {
  color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
  color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
  color: red;
}
</style>

<style scoped>
.btn-area {
  display: flex;
  justify-content: start;
}

.flag {
  /* column-count: 4;
  column-gap: 6px; */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-items: center;
  gap: 3px;
  /* width: 160px; */
}

.flag-icon {
  /* border: #4b92ff 1px solid; */
  width: 14px;
  /* margin: 2px; */
}

.ope {
  /* border: #9d9d9d 1px solid; */
  font-size: 16px;
  margin-left: 3px;
  /* border-radius: 2px; */
  color: #4b92ff;
  /* box-sizing: border-box; */
  /* padding: 2px 5px; */
}

.ope:hover {
  /* border: #4b92ff 1px solid; */
}

.holder {
  width: 40px;
  height: 16px;
  /* background: #4b92ff; */
  display: block;
  /* border: 1px solid #fff; */
  /* border: #4b92ff 1px solid; */
}

.showLink {
  color: #4b92ff;
  cursor: pointer;
  text-decoration: underline;
}

.up-button {
  /* width: 120px; */
  /* height: 32px;
  line-height: 32px; */
  color: #fff;
  font-size: 12px;
  background-color: #4b92ff;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 3px;
}

.up-button {
  color: rgb(75, 146, 255);
  font-size: 12px;
  border: solid 1px rgba(75, 146, 255, 0.5);
  padding: 6px 12px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 3px;
  margin: 0px 10px;
  background-color: rgba(75, 146, 255, 0.2);
  font-stretch: 100%;
}

.up-button:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
  border-color: #c6e2ff;
}

.up-file {
  border: none;
  display: none;
}

.content-title {
  display: flex;
  gap: 20px;
  /* padding-left: 20px; */
  margin-top: 6px;

  &>div {
    padding: 6px 10px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }

    &.active {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }
  }
}

.upload-btn {
  display: flex;
  justify-items: center;
}
</style>
